import Vue from 'vue'
import Router from 'vue-router'
import App from './App.vue'
import home from './components/pages/home.vue'

Vue.use(Router)

const router = new Router({
 routes: [
   {
     path: '/',
     name:'home',
     component: home,
   }
 ]
})

import './assets/styles/directory.scss'

Vue.prototype.$appName = 'How can this look better?'

new Vue({
 el: '#app',
 render: h => h(App),
 router
})